
import styled from "styled-components";
import React, {
  createRef,
  useEffect,
  createContext,
  useState,
  useMemo,
  useCallback,
} from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import BabylonManager from "../Babylon/BabylonManager";
import TopPanel from "../components/TopPanel";
import BottomPanel from "../components/BottomPanel";
import FloorSelector from "../components/FloorSelector";
import Gallery from "../components/Gallery";
import Loading from "../components/Loading";

import { useStore } from "../store/store";
import VRGallery from "../components/VRGallery";

const BabylonCanvas = styled.canvas`
  width: 100%;
  height: calc( 100vh - 0px );
  background-color: #1b1b1b;
  color: #fff;
  transition: all 0.3s ease-in-out;
  background-color: #27272;
  background-image: url(https://i.imgur.com/xoXPR5n.png);
  background-repeat: round;
  

`;
// overflow: "hidden";
export const GmContext = createContext(null);

const gmRef = createRef(null);
export default function Main() {
  const [gameManager, setGameManager] = useState(null);
  const [activeSlide, setActiveSlide] = useState("");
  const [activeIframeId, setActiveIframeId] = useState("");
  const [isLoading, setIsloading] = useState(true);

  const { activeMode, showGallery, showIframe, setShowGallery, setShowIframe, setActiveMode, setTrack } = useStore();

  const studioSceneHandlers = useMemo(() => {
    return {
      onNormalSpotClick: (data) => {
        console.log("on click Normal Spot on Flood id ===> ", data);
        setActiveSlide(data)
        setShowGallery(true);
      },
      onIframeSpotClick: (data) => {
        // window.open("https://ninety90i.co.uk/OPL/", "_self");

        setActiveIframeId(data);
        setShowIframe(true)
        console.log("on click IFrame Spot on Flood id ===> ", data);
      },
    };
  }, []);

  useEffect(() => {
    if (!gameManager) {
      const GManger = BabylonManager(gmRef.current, () => {
        setIsloading(false)
      }).GManger; //Create Babylonjs Ref
      GManger.studioSceneManager.handlers = studioSceneHandlers; //Hnadlers
      setGameManager(GManger);
    }
  }, [setGameManager, studioSceneHandlers, gameManager]);


  //actions
  const onChangeMode = useCallback((modeId) => {
    setActiveMode(modeId);
    if (modeId === "Building") {
      gameManager.studioSceneManager.activeFloorsView();
      setTrack([9]);
    } else {
      gameManager.studioSceneManager.activeAvailability();
      setTrack([]);
    }
  }, [gameManager]);

  return (
    <>
      <GmContext.Provider value={{ gameManager }}>

        <BabylonCanvas {...{}} className="canvas" ref={gmRef}>
        </BabylonCanvas>

        {isLoading && <Loading />}
        <TopPanel onChangeMode={onChangeMode} />
        {showIframe && <VRGallery activeIframeId={activeIframeId} />}
        {showGallery && <Gallery activeSlideId={activeSlide} />}
        {
          (activeMode === "Building" || activeMode === "Availability") && <FloorSelector />
        }
        <BottomPanel />
      </GmContext.Provider>
    </>
  );
}


